import { render, staticRenderFns } from "./new_story_button.vue?vue&type=template&id=5dd040c7&scoped=true&lang=pug"
import script from "./new_story_button.vue?vue&type=script&lang=js"
export * from "./new_story_button.vue?vue&type=script&lang=js"
import style0 from "./new_story_button.vue?vue&type=style&index=0&id=5dd040c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd040c7",
  null
  
)

export default component.exports